module.exports = __webpack_public_path__ + "static/media/atlantide_logo_c.69fa5f11.svg";